var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptxThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.332 100C33.332 141.421 66.9112 175 108.332 175C149.753 175 183.332 141.421 183.332 100H108.332H33.332Z",
    fill: "#DC4C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.332 25V100H183.332C183.332 58.5792 149.753 25 108.332 25Z",
    fill: "#F7A278"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.332 25C66.9112 25 33.332 58.5792 33.332 100H108.332V25Z",
    fill: "#C06346"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9971 141.667H23.6721C19.8055 141.667 16.668 138.53 16.668 134.663V65.3381C16.668 61.4715 19.8055 58.334 23.6721 58.334H92.9971C96.8638 58.334 100.001 61.4715 100.001 65.3381V134.663C100.001 138.53 96.8638 141.667 92.9971 141.667Z",
    fill: "#9B341F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1388 79.2168H41.668V120.883H50.1013V106.213H59.5846C67.4013 106.213 73.7388 99.8751 73.7388 92.0585V91.8168C73.7388 84.8585 68.0971 79.2168 61.1388 79.2168ZM64.8763 93.1585C64.8763 96.7376 61.9721 99.6418 58.393 99.6418H50.1013V85.7876H58.393C61.9721 85.7876 64.8763 88.6918 64.8763 92.271V93.1585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptxThumbnail);
export default __webpack_public_path__ + "static/media/pptx-thumbnail.30546aad7e5a30dc19188213bf9e0c23.svg";
export { ForwardRef as ReactComponent };